import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BankStatementTransaction } from "@/types/bank-statement";
import { TRANSACTION_CATEGORIES } from "../../constants/transaction-categories";

interface EditTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
  transaction: BankStatementTransaction | null;
  onSave: (updatedCategory: string) => void;
  isSaving?: boolean;
}

export function EditTransactionModal({ isOpen, onClose, transaction, onSave, isSaving }: EditTransactionModalProps) {
  const [category, setCategory] = useState<string>("");

  useEffect(() => {
    if (transaction) {
      setCategory(transaction.category || "");
    }
  }, [transaction]);

  if (!transaction) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[500px] bg-[#15203c] border-gray-700 text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Classificar Operação</DialogTitle>
        </DialogHeader>
        
        <div className="flex flex-col gap-4 py-4">
          <p className="text-sm text-gray-300">
            Classifique a transação <strong>{transaction.description}</strong> do dia {transaction.paymentDate}.
          </p>

          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-gray-200">Categoria da Operação</label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="h-10 px-3 py-2 bg-[#0c1427] border border-gray-600 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-[#7846ff]"
            >
              <option value="" disabled>Selecione uma categoria...</option>
              {TRANSACTION_CATEGORIES.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button onClick={onClose} variant="outline" className="border-gray-600 text-white hover:bg-gray-700" disabled={isSaving}>
            Cancelar
          </Button>
          <Button 
            onClick={() => onSave(category)} 
            className="bg-[#7846ff] hover:bg-[#6035d8] text-white"
            disabled={!category || isSaving}
          >
            {isSaving ? "Salvando..." : "Salvar Classificação"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
